import React, { useState } from 'react';
import { AuthSidebar } from '.';
import SignUpComponent from './Views/SignUp/index';
import { VIEWS } from './types';
import EmailLoginView from './Views/EmailLogin';
import ForgotPasswordView from './Views/ForgotPassword';
import SignInWithMagicLink from './Views/MagicLink';
import UpdatePasswordView from './Views/UpdatePassword';
export { default as AuthSidebar } from './AuthSidebar';
export * from './AuthContextProvider';
export { AuthValidationError } from './types';
type ViewType =
  | 'sign_in'
  | 'sign_up'
  | 'forgotten_password'
  | 'magic_link'
  | 'update_password';

export interface AuthProps {
  magicLink?: boolean;
  initialView?: ViewType;
}

function Auth({
  magicLink = false,
  initialView = 'sign_in',
}: AuthProps): JSX.Element | null {
  const [authView, setAuthView] = useState<ViewType>(initialView);
  const [defaultEmail, setDefaultEmail] = useState('');
  const [defaultPassword, setDefaultPassword] = useState('');

  const SidebarContainer = () => {
    switch (authView) {
      case VIEWS.MAGIC_LINK:
      case VIEWS.SIGN_IN:
        return (
          <AuthSidebar title="Sign in to your Account">
            <div className="flex">
              <SidebarLink active title="Sign In" />
              <SidebarLink
                title="Create Account"
                onClick={() => {
                  setAuthView(VIEWS.SIGN_UP);
                }}
              />
            </div>
          </AuthSidebar>
        );
      case VIEWS.SIGN_UP:
        return (
          <AuthSidebar title="Create a new Account">
            <div className="flex items-center justify-start">
              <SidebarLink
                title="Sign In"
                onClick={() => {
                  setAuthView(VIEWS.SIGN_IN);
                }}
              />
              <SidebarLink active title="Create Account" />
            </div>
          </AuthSidebar>
        );
      case VIEWS.FORGOTTEN_PASSWORD:
        return (
          <AuthSidebar title="Reset your password">
            <div className="flex">
              <SidebarLink active title="Reset Password" />
              <SidebarLink
                onClick={() => {
                  setAuthView(VIEWS.SIGN_IN);
                }}
                title="Sign In"
              />
            </div>
          </AuthSidebar>
        );
      case VIEWS.UPDATE_PASSWORD:
        return (
          <AuthSidebar title="Update your password">
            <div className="flex">
              <SidebarLink active title="Update Password" />
              <SidebarLink
                onClick={() => {
                  setAuthView(VIEWS.SIGN_IN);
                }}
                title="Sign In"
              />
            </div>
          </AuthSidebar>
        );
      default:
        return null;
    }
  };

  const Container: React.FC<{ children: React.ReactNode }> = ({ children }) => (
    <div className={'h-screen w-screen flex'}>
      <SidebarContainer />
      {children}
    </div>
  );

  const sharedProps = () => ({
    authView,
    setAuthView,
    setDefaultEmail,
    setDefaultPassword,
    defaultEmail,
    defaultPassword,
    magicLink,
  });

  switch (authView) {
    case VIEWS.SIGN_IN:
      return (
        <Container>
          <EmailLoginView {...sharedProps()} />
        </Container>
      );
    case VIEWS.SIGN_UP:
      return (
        <Container>
          <SignUpComponent {...sharedProps()} />
        </Container>
      );
    case VIEWS.FORGOTTEN_PASSWORD:
      return (
        <Container>
          <ForgotPasswordView />
        </Container>
      );

    case VIEWS.MAGIC_LINK:
      return (
        <Container>
          <SignInWithMagicLink {...sharedProps()} />
        </Container>
      );

    case VIEWS.UPDATE_PASSWORD:
      return (
        <Container>
          <UpdatePasswordView />
        </Container>
      );

    default:
      return null;
  }
}

const SidebarLink = ({ title = '', onClick = () => {}, active = false }) => {
  return (
    <div
      role="button"
      tabIndex={0}
      className={
        !active
          ? 'text-gray-500 cursor-pointer transition ease-in-out duration-150 hover:text-white border-b-2 border-transparent mr-3'
          : 'text-white border-b-2 border-primary mr-3 transition ease-in-out duration-150'
      }
      onClick={() => {
        if (!active) onClick();
      }}
    >
      {title}
    </div>
  );
};
export default Auth;
